import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";

export function useSetPromoStatus() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const setPromoStatus = async (
    promoId: string,
    isActive: boolean,
  ): Promise<void> => {
    try {
      setLoading(true);
      await createAxiosInstance().post(`/promos/status`, { promoId, isActive });
    } finally {
      setLoading(false);
    }
  };

  return { setPromoStatus, loading };
}
